<div class="container">
  <ng-container *ngIf="icon">
    <dap-lib-icon [attr.data-cy]="'icon-name-' + icon" [iconSize]="'24'" [name]="icon"></dap-lib-icon>
  </ng-container>
  <h2 class="headline-5" data-cy="person-name">{{ name }}</h2>
</div>
